import request from '../../utils/request';

export const savePoiService = (data, id = 0) => {
  const dataToSend = {
    data,
  };
  if (id > 0) {
    
    return async dispatch => {
      const response = await dispatch(
        request('/point-of-interests/' + id, {
          method: 'PUT',
          data,
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    
    const response = await dispatch(
      request('/point-of-interests', {
        method: 'POST',
        data,
      }),
    );
    return response;
  };
};

export const getPoisService = (params = null) => {
  if (params === null) {
    return async dispatch => {
      const response = await dispatch(
        request('/point-of-interests', {
          method: 'GET',
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interests', {
        method: 'GET',
        params,
      }),
    );
    return response;
  };
};

export const getPoisDropdownService = (params = null) => {
  if (params === null) {
    return async dispatch => {
      const response = await dispatch(
        request('/point-of-interests/dropdown', {
          method: 'GET',
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interests/dropdown', {
        method: 'GET',
        params,
      }),
    );
    return response;
  };
};

export const getPoiByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interests/' + id, {
        method: 'GET',
      }),
    );
    return response;
  };
};

export const getPoiImageByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interests/' + id + '/images', {
        method: 'GET',
      }),
    );
    return response;
  };
};

export const getPoiCompleteByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interests/' + id + '/complete', {
        method: 'GET',
      }),
    );
    return response;
  };
};

export const getSimplePoiListService = (idList = '', all = false) => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interests/exportPdf', {
        method: 'GET',
        params: {
          id: idList,
          all,
        },
      }),
    );
    return response;
  };
};

export const getCustomPoiListService = (idList = '') => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interests/customPdf', {
        method: 'GET',
        params: {
          id: idList,
        },
      }),
    );
    return response;
  };
};

export const deletePoisService = array => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interests', {
        method: 'DELETE',
        params: { idList: array },
      }),
    );
    
    return response;
  };
};
